module.exports = __webpack_public_path__ + "static/media/Pocket_Casts_logo.17ddd66b.png";